import React from 'react';
import { Link } from 'react-router-dom';

function Team() {
  return (
    <>
      <div class="page-banner-area">
        <div class="container">
          <div class="page-banner-content">
            <h2>Team</h2>
            <ul>
              <li>
                <Link to={"/"}>Home</Link>
              </li>
              <li>Team</li>
            </ul>
          </div>
        </div>
      </div>
      <section class="team-area bg-ffffff pt-100 pb-70">
        <div class="container">
          <div class="section-title">
            <span>Expert people</span>
            <h2>Global leadership team</h2>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="single-team-box">
                <div class="team-image">
                  <img src="https://templates.envytheme.com/leve/default/assets/img/team/team-1.jpg" alt="image" />
                </div>
                <div class="team-content">
                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-linkedin'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-twitter'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-facebook'></i>
                      </a>
                    </li>
                  </ul>
                  <h3>KhumRaj Khadka</h3>
                  <span>Director</span>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="single-team-box">
                <div class="team-image">
                  <img src="https://templates.envytheme.com/leve/default/assets/img/team/team-2.jpg" alt="image" />
                </div>
                <div class="team-content">
                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-linkedin'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-twitter'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-facebook'></i>
                      </a>
                    </li>
                  </ul>
                  <h3>Mahesh Bishwakarma</h3>
                  <span>Director</span>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6">
              <div class="single-team-box">
                <div class="team-image">
                  <img src="https://templates.envytheme.com/leve/default/assets/img/team/team-3.jpg" alt="image" />
                </div>
                <div class="team-content">
                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-linkedin'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-twitter'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-facebook'></i>
                      </a>
                    </li>
                  </ul>
                  <h3>Mukesh Kumar</h3>
                  <span>IT Manager</span>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6">
              <div class="single-team-box">
                <div class="team-image">
                  <img src="https://templates.envytheme.com/leve/default/assets/img/team/team-4.jpg" alt="image" />
                </div>
                <div class="team-content">
                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-linkedin'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-twitter'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-facebook'></i>
                      </a>
                    </li>
                  </ul>
                  <h3>Sobha Ram Oli</h3>
                  <span>Account Expert</span>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6">
              <div class="single-team-box">
                <div class="team-image">
                  <img src="https://templates.envytheme.com/leve/default/assets/img/team/team-5.jpg" alt="image" />
                </div>
                <div class="team-content">
                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-linkedin'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-twitter'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-facebook'></i>
                      </a>
                    </li>
                  </ul>
                  <h3>Bikram Rawat</h3>
                  <span>Account Expert</span>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6">
              <div class="single-team-box">
                <div class="team-image">
                  <img src="https://templates.envytheme.com/leve/default/assets/img/team/team-6.jpg" alt="image" />
                </div>
                <div class="team-content">
                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-linkedin'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-twitter'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class='bx bxl-facebook'></i>
                      </a>
                    </li>
                  </ul>
                  <h3>Santu</h3>
                  <span>Account Assistant</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Team;
